import { runCommand } from './command';
import { logSuccess } from './logger';
import { move, rimRaf, writeFile } from './fs';

const GIT_IGNORE_CONTENT = `
  node_modules
  dist
  .idea
  .env
  `;

export async function create() {
  await runCommand('npm init --force');

  await runCommand('npm i @evergis/template@latest');
  await move('./node_modules/@evergis/template/react/*', './');
  await move('./node_modules/@evergis/template/react/.[!.]*', './');
  await rimRaf('node_modules');

  await runCommand('npm i');
  await writeFile('.gitignore', GIT_IGNORE_CONTENT);

  logSuccess('project created');
}
